export default "__VITE_ASSET__3cdad035__"